import { Injectable } from '@angular/core'

@Injectable()
export class MySharedService {
  // TODO: Cleanup file

  public ApplicationVersion: any = 'BETA'
  public LocalDeployment: boolean = true
  public TermsAndConditions: any = 'assets/documents/TermsAndConditions.pdf'
  public CookiePolicy: any = 'assets/documents/CookiePolicy.pdf'
  public PrivacyPolicy: any = 'assets/documents/PrivacyPolicy.pdf'
  public logoImage: any = 'assets/images/Logo.png'
  public fallbackUrl: any = 'https://serviceathand.com/default-page'

  public ShopOrServiceVAL: any
  public CountryVAL: any = 'South Africa' // TODO: release 1.3 ~ international expansion
  public ProvinceVAL: any
  public SuburbVAL: any
  public CategoryVAL: any
  public SelectedUser: any
  public SelectedJob: any
  public Username: any

  public MainInfo: any

  public WeekdayList: any = [
    { Weekday: 'Monday' },
    { Weekday: 'Tuesday' },
    { Weekday: 'Wednesday' },
    { Weekday: 'Thursday' },
    { Weekday: 'Friday' },
    { Weekday: 'Saturday' },
    { Weekday: 'Sunday' },
  ]

  public loginStatus: any

  getLoginStatus() {
    return this.loginStatus
  }

  getFallbackUrl() {
    return this.fallbackUrl
  }

  getSelectedUser() {
    return this.SelectedUser
  }

  getSelectedJob() {
    return this.SelectedJob
  }

  getAppVersion() {
    return this.ApplicationVersion
  }

  getTermsAndConditions() {
    return this.TermsAndConditions
  }

  getCookiePolicy() {
    return this.CookiePolicy
  }

  getPrivacyPolicy() {
    return this.PrivacyPolicy
  }

  getLogoImage() {
    return this.logoImage
  }

  getWeekdayList() {
    return this.WeekdayList
  }

  getLocalDeployment() {
    return this.LocalDeployment
  }

  setLoginStatus(value: any) {
    this.loginStatus = value
  }

  setMainInfo(value: any) {
    this.MainInfo = value
  }

  setSelectedUser(value: any) {
    this.SelectedUser = value
  }

  setSelectedJob(value: any) {
    this.SelectedJob = value
  }

  getMainInfo() {
    return this.MainInfo
  }

  setShopOrServiceVAL(value: string) {
    this.ShopOrServiceVAL = value
  }

  setCountryVAL(value: string) {
    // this.CountryVAL = value  // TODO: release 1.3 ~ international expansion
    this.CountryVAL = this.CountryVAL
  }

  setProvinceVAL(value: any) {
    this.ProvinceVAL = value
  }

  setSuburbVAL(value: any) {
    this.SuburbVAL = value
  }

  setCategoryVAL(value: any) {
    this.CategoryVAL = value
  }

  getShopOrServiceVAL() {
    return this.ShopOrServiceVAL
  }

  getCountryVAL() {
    return this.CountryVAL
  }

  getProvinceVAL() {
    return this.ProvinceVAL
  }

  getSuburbVAL() {
    return this.SuburbVAL
  }

  getCategoryVAL() {
    return this.CategoryVAL
  }

  setUsername(value: string) {
    this.Username = value
  }

  getUsername() {
    return this.Username
  }
}
